/* eslint-disable react/prop-types */
import {Box} from '@mui/material';
import {memo} from 'react';
import {Handle, Position} from 'reactflow';

function GuideNode() {
  const handleStyle = {transform: 'rotate(0deg)', opacity: '0'};
  return (
    <>
      <Box width={'250px'} height={'200px'} display='flex' alignItems='flex-end'></Box>
      <Handle id='leftSource' style={handleStyle} type='source' position={Position.Left} />
      <Handle id='topSource' style={handleStyle} type='source' position={Position.Top} />
      <Handle id='rightSource' style={handleStyle} type='source' position={Position.Right} />
      <Handle id='bottomSource' style={handleStyle} type='source' position={Position.Bottom} />

      <Handle id='leftTarget' style={handleStyle} type='target' position={Position.Left} />
      <Handle id='topTarget' style={handleStyle} type='target' position={Position.Top} />
      <Handle id='rightTarget' style={handleStyle} type='target' position={Position.Right} />
      <Handle id='bottomTarget' style={handleStyle} type='target' position={Position.Bottom} />
    </>
  );
}

export default memo(GuideNode);
